import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = {
  key: 0,
  class: "field-title"
}

import "components/common/fields.css";
import { CoercableComponent } from "features/feature";
import { computeOptionalComponent } from "util/vue";
import { ref, toRef, watch } from "vue";
import VueNextSelect from "vue-next-select";
import "vue-next-select/dist/index.css";

export type SelectOption = { label: string; value: unknown };


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    modelValue: null,
    options: null,
    placeholder: null,
    closeOnSelect: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
    (e: "update:modelValue", value: unknown): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    title?: CoercableComponent;
    modelValue?: unknown;
    options: SelectOption[];
    placeholder?: string;
    closeOnSelect?: boolean;
}




const titleComponent = computeOptionalComponent(toRef(props, "title"), "span");

const value = ref<SelectOption | undefined>(
    props.options.find(option => option.value === props.modelValue)
);
watch(toRef(props, "modelValue"), modelValue => {
    if (value.value?.value !== modelValue) {
        value.value = props.options.find(option => option.value === modelValue);
    }
});

function onUpdate(value: SelectOption) {
    emit("update:modelValue", value.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(titleComponent))
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(titleComponent))))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(VueNextSelect), {
      options: __props.options,
      modelValue: value.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        onUpdate
      ],
      min: 1,
      "label-by": "label",
      placeholder: __props.placeholder,
      "close-on-select": __props.closeOnSelect
    }, null, 8, ["options", "modelValue", "placeholder", "close-on-select"])
  ]))
}
}

})